const initState = {
    isLoading: false,
    data: [],
    error: null,
}

export default function QuickPackReducer(state = initState, action) {
    switch (action.type) {
        case "SET_QUICK_PACK_LIST_LOADING":
            return {
                ...state,
                isLoading: true,
            }
        case "SET_QUICK_PACK_LIST_DATA":
            return {
                ...state,
                data: action.payload,
                isLoading: false,
            }
        case "SET_QUICK_PACK_LIST_ERROR":
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            }
        case "CLEAR_QUICK_PACK":
            return {
                ...state,
                data: [],
                isLoading: false,
                error: null,
            }
        default:
            return state
    }
}